<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import Select, { type SelectChangeEvent } from 'primevue/select';
import { useCaseStore } from '@/stores/case';

const props = defineProps({
  initialCaseId: {
    type: String
  }
});

const caseStore = useCaseStore();

onMounted(() => {
  (async () => {
    await caseStore.getStudyCases(undefined, undefined, 'export');
    if (props.initialCaseId) {
      selectedCase.value = caseStore.studyCaseList.find(caseItem => caseItem.identifier == props.initialCaseId);
    } else {
      selectedCase.value = caseStore.studyCaseList[0];
    }
    emits('onCasesFetched', selectedCase.value);
  })();
});

const isMobile = ref(window.matchMedia('(max-width: 768px)').matches);

const minWidth = computed(() => isMobile.value ? `150px` : '200px');

const selectedCase = ref();

const emits = defineEmits(['onCaseChanged', 'onCasesFetched']);

const onSelectChange = (event: SelectChangeEvent) => {
  emits('onCaseChanged', event.value);
};
</script>

<template>
  <Select v-model="selectedCase"
    class="case-select-input"
    optionLabel="label"
    filter
    @click.stop
    :options="caseStore.studyCaseList"
    @change="onSelectChange"/>
</template>

<style scoped lang="scss">
.case-select-input {
    min-width: v-bind(minWidth);
}
</style>
